
    import { defineComponent } from 'vue';
    declare var hcaptcha: any;
    import { loadApiEndpointIfNotAlready } from './hcaptchascript';
    export default defineComponent({
        data() {
            return {
                widgetId: 0
            }
        },
        props: {
            lan: String,
            sitekey:String
        },
        mounted() {
            let self = this;
            
            loadApiEndpointIfNotAlready({ hl: this.lan, apiEndpoint: "https://js.hcaptcha.com/1/api.js" }).then(self.onApiLoaded).catch(self.onApiError);

        },
        methods: {
            execute() {
                hcaptcha.execute(this.widgetId);
            },
            reset() {
                hcaptcha.reset(this.widgetId);
            },
            render() {
                if (hcaptcha) {
                    this.widgetId = hcaptcha.render('hcaptcha', {
                        sitekey: this.sitekey,
                        size: 'invisible',
                        callback: (response: string) => {
                            this.$emit('verify', response);
                            this.reset();
                        }
                    })
                }
            },
            onApiLoaded() {
                this.render();
            },
            onApiError(err:string) {
                console.error(err);
            }
        }
    });
